// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__jvuOS","question":"Question_question__2JNFm","description":"Question_description__1jMMD"};